import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';

import { Observable, Subject, timer } from 'rxjs';
import { filter, switchMap, takeUntil } from 'rxjs/operators';
import { AuthenticatedUser, Notification } from 'src/app/shared/models';
import { AuthenticationService, NotificationsService } from 'src/app/shared/services';
import { TranslationService } from 'src/app/shared/services/translation/translation.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
})
export class ToolbarComponent implements OnInit, OnDestroy {
 
  public get availableTranslationLocales(): { key: string; locale: string }[] {
    return this.translationService.availableTranslationLocales;
  }

  public get currentTranslationLocale(): string {
    return this.translationService.currentTranslationLocale;
  }
  public get numberOfUnreadNotifications(): number {
    // TODO: Should only return the number of unread notifications
    return this.notifications.length;
  }

  public baseUrl = environment.baseUrl;

  public complete$ = new Subject();

  public notifications: Notification[] = [];

  @Output() public toggleSidenav = new EventEmitter();

  public user$: Observable<AuthenticatedUser | null>;

  public userName: string;

  constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly notificationsService: NotificationsService,
    private readonly router: Router,
    private readonly keycloak: KeycloakService,
    private readonly translationService: TranslationService
  ) {}

  public ngOnDestroy() {
    this.complete$.next();
    this.complete$.complete();
  }

  public ngOnInit() {  
    this.user$ = this.authenticationService.user$;   
    timer(0, 60000)
      .pipe(
        filter(() => (this.authenticationService.currentUser ? true : false)),
        takeUntil(this.complete$),
        switchMap(() => this.notificationsService.getNotifications(this.authenticationService.currentUser.userId))
      )
      .subscribe(notifications => {
        this.notifications = notifications;
      });

    this.user$
      .pipe(takeUntil(this.complete$))
      .subscribe(
        () =>
          (this.userName = this.authenticationService.currentUser ? this.authenticationService.currentUser.name : '')
      );
  }
  
  public onClickLogout(): void {
    localStorage.clear();
    sessionStorage.clear();
    this.keycloak.logout(window.location.origin);
  }

  public onClickToggleToolbar(): void {
    this.toggleSidenav.emit();
  }

  public changeLanguage(locale: { key: string; locale: string }): void {
    this.translationService.setLocale(locale.locale);
    window.location.reload();
  }

  public changePassword() {
    window.location.href = environment.keycloakOpenId + "&redirect_uri="+ window.location.origin +"&kc_action=UPDATE_PASSWORD";
  }
}
